import { useEffect, useState } from 'react';

// waits one animation frame before marking as mounted.
// this gives parent layouts (like modals) time to finish measuring
// so children that depend on size (e.g. flatlist) get correct dimensions.
export const useDeferredMount = () => {
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    const id = requestAnimationFrame(() => setMounted(true));
    return () => cancelAnimationFrame(id);
  }, []);
  return mounted;
};

export default useDeferredMount;
